import React from 'react';
import styled from 'styled-components';
import { prop } from 'styled-tools';

const StyledMapWrapperInner = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: ${prop('width')};
    height: ${prop('height')};
    transform: scale(${prop('previewZoom')});
    transform-origin: 0 0;
`;

const MapWrapperInner = ({ width, height, previewZoom, children, ...props }) => {
    return (
        <StyledMapWrapperInner width={width} height={height} previewZoom={previewZoom} {...props}>
            {children}
        </StyledMapWrapperInner>
    );
};

export default MapWrapperInner;
